import { useContext } from 'react';
import { RootContext } from '../../../stores';

export default function useRootStore() {
    const rootStore = useContext(RootContext);
    return rootStore;
}